import StatusBadge from '@/components/base/StatusBadge';
import { needsAttention } from '@/utils/wallet';
import type { Wallet } from '@/types/portal';

interface WalletAttentionPanelProps {
  wallets: Wallet[];
}

export default function WalletAttentionPanel({ wallets }: WalletAttentionPanelProps) {
  const attention = wallets.filter(needsAttention);

  return (
    <div className="sticky top-6 space-y-5">
      <section
        className={`rounded-lg border ${
          attention.length > 0 ? 'border-primary-200 bg-primary-50' : 'border-background-200 bg-background-50'
        }`}
      >
        <header className="flex items-center gap-2 border-b border-background-200 px-5 py-3.5">
          <i
            className={
              attention.length > 0 ? 'ri-alert-line text-primary-700' : 'ri-shield-check-line text-accent-700'
            }
          />
          <h3 className="font-heading text-sm font-semibold text-foreground-950">
            Wallets needing attention
          </h3>
        </header>
        <ul className="divide-y divide-background-100">
          {attention.length === 0 ? (
            <li className="px-5 py-4 text-sm text-foreground-600">
              Every wallet is active and funding-ready.
            </li>
          ) : (
            attention.map((wallet) => (
              <li key={wallet.id} className="flex items-start justify-between gap-3 px-5 py-3">
                <div className="min-w-0">
                  <p className="truncate text-sm font-medium text-foreground-900">
                    {wallet.ownerName}
                  </p>
                  <p className="truncate text-xs text-foreground-500">
                    {wallet.market}
                  </p>
                </div>
                <StatusBadge status={wallet.status} className="shrink-0" />
              </li>
            ))
          )}
        </ul>
      </section>
    </div>
  );
}